export enum PhotosType {
  square = 'square' /** URL до фотографии 250x250 */,
  squareLarge = 'squareLarge' /** URL до фотографии 600x600 */,
  huge = 'huge' /** URL до фотографии 1000x750 */,
  xHuge = 'xHuge',
}

export enum PhotosSize {
  squareSmall = 150,
  square = 300,
  squareLarge = 600,
}
